import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { AppSessionService } from "../app-session/app-session.service";

import {
  setSimpleFilterQuery,
} from "../../utils/tableUtils";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class ManageFileService {
  private FILES_URL = this.appSession.baseUrl + "/api/v1/multimedia/files";

  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);

    const url = `${this.FILES_URL}`;
    return this.http.post<any>(url, formData).pipe(
      catchError((error) => throwError(error))
    );
  }

  fileDetails(fileId: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.FILES_URL}/${fileId}`;
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  deleteFile(id: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.FILES_URL}/${id}`;
    return this.http.delete<any>(url, { headers }).pipe(
      catchError((error) => throwError(error))
    );
  }

  getFilesList(filteringArgs?: any): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (filterQuery.length > 0) {
      headers = headers.append("query", `${filterQuery}`);
    }

    const url = `${this.FILES_URL}`;
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  getFileThumbnail(fileId: string): Observable<Blob> {
    const url = `${this.FILES_URL}/${fileId}/download?fileType=THUMBNAIL`; 
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadThumbnailFile(fileId: string): Observable<Blob> {
    const url = `${this.FILES_URL}/${fileId}/download?fileType=MOVIE`; 
    return this.http.get(url, { responseType: 'blob' });
  }
}
